<template>
  <ion-page>
    <master-layout pageTitle="ویرایش اطلاعات خودرو">
      <ion-card>
        <ion-card-content>
          <Loading :is="!carLoaded" v-if="!carLoaded"></Loading>
          <div v-if="carLoaded">
            <div v-if="customerCar">
              <div class="h5">مشتری :
              {{customer.fullname}}</div>
              <AjaxForm route="car/edit">
                <input type="hidden" readonly name="id" :value="customerCar._id">
                <div class="mt-2">
                  <label>عنوان خودرو</label>
                  <input class="form-control" type="text" name="title" :value="customerCar.title">
                </div>
                <div class="mt-2">
                  <label>تیپ خودرو</label>
                  <ali-ajax-select :selected="carTypeSelected" route="app/GetTypeForSelect" title="تیپ خودرو" itemTitle="title" name="type_id" desc="جستجو تیپ خودرو" itemId="_id"></ali-ajax-select>
                </div>
                <div class="mt-2">
                  <label>سال ساخت</label>
                  <input class="form-control" name="produce_year" :value="customerCar.produce_year">
                </div>
                <div class="mt-2">
                  <label>کیلومتر فعلی خودرو</label>
                  <input type="text" name="current_km" class="only_number form-control" :value="customerCar.current_km">
                </div>
                <div>
                  <label>پلاک خودرو</label>
                  <div class="plaque">
                    <div class="first">
                      <div class="flag green"></div>
                      <div class="flag white"></div>
                      <div class="flag red"></div>
                      <div>I.R.</div>
                      <div>IRAN</div>
                    </div>
                    <div class="second">
                      <div>
                        <input :value="customerCar.two_digit" name="two_digit" maxlength="2" minlength="2" placeholder="--" type="text" class="p-input">
                      </div>
                      <div class="select-div">
                        <select autocomplete="off" class="form-control" name="alphabet">
                          <option :selected="customerCar.alphabet === item" v-for="(item,index) in plaqueAlphabet" :key="index" :value="item">{{item}}</option>
                        </select>
                      </div>
                      <div>
                        <input :value="customerCar.five_digit" name="five_digit" maxlength="3" minlength="3" placeholder="---" type="text" class="p-input">
                      </div>
                    </div>
                    <div class="third">
                      <div>ایران</div>
                      <input :value="customerCar.ir_code" name="ir_code" type="tel" class="two_number_input" placeholder="--" maxlength="2" minlength="2">
                    </div>
                  </div>
                </div>
                <div class="">
                  <button class="btn btn-success btn-block btn-lg" type="submit">ویرایش اطلاعات خودرو</button>
                </div>
              </AjaxForm>
            </div>
            <div v-if="error" class="alert alert-danger">
              {{error}}
            </div>
          </div>
        </ion-card-content>
      </ion-card>
    </master-layout>
  </ion-page>
</template>

<script>
import {
  IonCard, IonCardTitle, IonCardContent, IonPage
} from "@ionic/vue";
import {mapActions} from "vuex";
import Loading from "@/components/Loading";
import AliSelect from "@/components/aliSelect";
import AliAjaxSelect from "@/components/aliAjaxSelect";
import AjaxForm from "@/components/AjaxForm";

export default {
  data()
  {
    return {
      id:null,
      carLoaded: false,
      customerCar:null,
      customer : null,
      error:null,
      plaqueAlphabet : [
        'الف','ب','پ','ت','ث','ج','د','ز','ژ','س','ش','ص','ط','ع','ف',
        'ق','ک','ل','م','ن','و','ه','ی'
      ],
      carTypeSelected : {}
    };
  },
  async created()
  {
    this.id = this.$route.params.id;
    const result = await this.getCar(this.id);
    if (result)
    {
      if (result.ok)
      {
        this.carTypeSelected = [result.car.car_type];
        const customer_obj = await this.getCustomer({id : result.car.user_id});
        if (customer_obj.ok)
          this.customer = customer_obj.customer;
        this.carLoaded = true;
        this.customerCar = result.car;
      }
      else
      {
        this.carLoaded = true;
        this.error = result.error
      }
    }
    else
    {
      this.carLoaded = true;
      this.error = 'خطا در برقراری ارتباط با سرور'
    }
  },
  components: {
    AjaxForm,
    Loading,
    AliSelect,
    AliAjaxSelect,
    IonCard, IonCardTitle, IonCardContent, IonPage
  },
  methods: {
    ...mapActions("customerCar", {
      getCar: 'getCar'
    }),
    ...mapActions("customer", {
      getCustomer: 'getCustomer'
    }),
  }
};

</script>

<style scoped>
.h5 {
  font-weight: 900;
  font-size: 15px;
  align-self: center;
  color: #000000b3;
}
.plaque{
  justify-content: space-between;
  display: flex;
  border: 1px solid silver;
  border-radius: 4px;
  direction: ltr;
  text-align: center;
  height: 50px;
  margin-top: 5px;
}
.second
{
  width: 70%;
  border-right: 1px solid silver;
  border-left: 1px solid silver;
  display: flex;
  justify-content: space-between;
}
.first{
  width: 10%;
  font-size: 9px;
  text-align: left;
  background-color: #003399;
  color: white;
  line-height: 12px;
}
.third
{
  width: 20%;
}
.select-div
{
  width: 100%;
}
.p-input{
  width: 100%;
  height: 48px;
  border: none;
  font-size: 20px;
  text-align: center;
  padding: 0;
}
.select-div .form-control
{
  height: 48px;
  border-radius: 0!important;
  background: white;
  border: none;
}
.two_number_input{
  border: none;
  width: 100%;
  text-align: center;
}
.red
{
  background: #e0002c;
}
.green
{
  background: #009b49;
}
.white
{
  background: white;
}
.flag
{
  height: 8px;
  width: 100%;
}
</style>